import * as eventTypes from "features/folder/edit/states/eventTypes";
import * as types from "../actionTypes";
import initialState from "reducers/initialState";

export const facilityRevolvingTypesReducer = (state = initialState.facilities.facilityRevolvingTypes, action) => {
  switch (action.type) {
    case types.LOAD_FACILITY_REVOLVING_TYPES_STARTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }

    case types.LOAD_FACILITY_REVOLVING_TYPES_SUCCEEDED: {
      return {
        ...state,
        loading: false,
        loaded: true
      };
    }

    case types.LOAD_FACILITY_REVOLVING_TYPES_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }

    default:
      return state;
  }
};

export const facilityFlexibilityRulesReducer = (state = initialState.facilities.facilityFlexibilityRules, action) => {
  switch (action.type) {
    case types.LOAD_FACILITY_FLEXIBILITY_RULES_STARTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }

    case types.LOAD_FACILITY_FLEXIBILITY_RULES_SUCCEEDED: {
      return {
        ...state,
        loading: false,
        loaded: true
      };
    }

    case types.LOAD_FACILITY_FLEXIBILITY_RULES_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }

    default:
      return state;
  }
};

export const facilityCreditLineStatusesReducer = (
  state = initialState.facilities.facilityCreditLineStatuses,
  action
) => {
  switch (action.type) {
    case types.LOAD_FACILITY_CREDIT_LINE_STATUSES_STARTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }

    case types.LOAD_FACILITY_CREDIT_LINE_STATUSES_SUCCEEDED: {
      return {
        ...state,
        loading: false,
        loaded: true
      };
    }

    case types.LOAD_FACILITY_CREDIT_LINE_STATUSES_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }

    default:
      return state;
  }
};

export const facilityPurposesForApplicationReducer = (
  state = initialState.facilities.facilityPurposesForApplication,
  action
) => {
  switch (action.type) {
    case types.LOAD_FACILITY_PURPOSES_FOR_APPLICATION_STARTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }

    case types.LOAD_FACILITY_PURPOSES_FOR_APPLICATION_SUCCEEDED: {
      return {
        ...state,
        loading: false,
        loaded: true
      };
    }

    case types.LOAD_FACILITY_PURPOSES_FOR_APPLICATION_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }

    default:
      return state;
  }
};

export const facilityPartnerGroupsReducer = (state = initialState.facilities.facilityPartnerGroups, action) => {
  switch (action.type) {
    case types.LOAD_PARTNER_GROUPS_STARTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }

    case types.LOAD_PARTNER_GROUPS_SUCCEEDED: {
      return {
        ...state,
        loading: false,
        loaded: true
      };
    }

    case types.LOAD_PARTNER_GROUPS_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: false
      };
    }

    default:
      return state;
  }
};

export const transferFacilityToERPPermissionsReducer = (
  state = initialState.facilities.transferFacilityToERPPermissions,
  action
) => {
  switch (action.type) {
    case types.LOAD_TRANSFER_FACILITY_TO_ERP_PERMISSIONS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };

      return result;
    }

    case types.LOAD_TRANSFER_FACILITY_TO_ERP_PERMISSIONS_SUCCEEDED: {
      const { key, payload } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, transferToERPPermissions: payload };

      return result;
    }

    case types.LOAD_TRANSFER_FACILITY_TO_ERP_PERMISSIONS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: false };

      return result;
    }

    case eventTypes.FOLDER_STATE_UPDATED: {
      const { facilityId: key } = action.event.eventBody;
      if (!key) return state;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: false };

      return result;
    }

    default:
      return state;
  }
};

export const facilityWarrantiesReducer = (state = initialState.facilities.facilityWarranties, action) => {
  switch (action.type) {
    case types.LOAD_FACILITY_WARRANTIES_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };

      return result;
    }

    case types.LOAD_FACILITY_WARRANTIES_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };

      return result;
    }

    case types.LOAD_FACILITY_WARRANTIES_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: false };

      return result;
    }

    default:
      return state;
  }
};
